import {
  GroupBusinessInfo,
  GroupDoc,
  GroupInheritanceMap,
  GroupParticipant,
  GroupSettings
} from './changes'

export type InheritFromGroupsRequest = Record<string, GroupInheritanceMap>

export interface InheritanceIssue {
  childGroupId: string
  parentGroupId: string
  code: number
  reason: string
}

export interface InheritanceStatusResponse {
  success: boolean
  valid: boolean
  issues: InheritanceIssue[]
}

export interface InheritFromGroupsError {
  childGroupId: string
  success: false
  error: string
  code: -103 | -104 | -109 | -118 | -123
  parentGroups?: string[]
}

export interface InheritFromGroupsResponse {
  success: boolean
  message: string
  groups: GroupDoc[]
  issues?: InheritanceIssue[]
  errors?: InheritFromGroupsError[]
}

export enum GROUP_INFO_ACTION_TYPES {
  METADATA = '3',
  ADD_PARTICIPANTS = '1',
  EDIT_PARTICIPANTS = '2',
  GROUP_SETTINGS = '4'
}

export interface UpdateGroupData {
  DeviceChangeID: string | null
  ActionType: string
  UserID: string | null
  GroupID: string
}

export interface UpdateLinkData extends UpdateGroupData {
  PrivateLinkUrl: string
  PrivateLinkPassword: string
}

export interface UpdateGroupColorData extends UpdateGroupData {
  GroupColor: string
}

export interface UpdateTitleData extends UpdateGroupData {
  Name: string
}

export interface UpdateBusinessInfoData extends UpdateGroupData {
  BusinessInfo: GroupBusinessInfo
}

export interface UpdatePhotoData extends UpdateGroupData {
  Photo: string
}

export interface UpdateGroupSettingsData extends UpdateGroupData {
  GroupSettings: GroupSettings
}

export interface UpdateGroupPrivacyMode extends UpdateGroupSettingsData {
  PrivacyMode: string
}

export interface AddParticipantData extends UpdateGroupData {
  PendingParticipants: Record<string, GroupParticipant>
}

export interface UpdateParticipantData extends UpdateGroupData {
  Participants: Record<string, GroupParticipant>
}

export interface UpdatePersonalGroupSyncStatusData extends UpdateGroupData {
  PersonalGroupSyncStatus: string
}

export interface ResetConvertedGroupData
  extends UpdatePersonalGroupSyncStatusData,
    UpdateLinkData,
    UpdateParticipantData,
    AddParticipantData {}
